import React, {
  ChangeEventHandler,
  FC,
  ForwardedRef,
  forwardRef,
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useState,
} from 'react';

import * as S from './styles';
import { IInputCheckboxLabelStyles } from './styles';
export type IInputCheckboxProps = InputHTMLAttributes<HTMLInputElement> &
  IInputCheckboxLabelStyles & {
    label: string;
  };

const InputCheckbox: FC<IInputCheckboxProps> = forwardRef(
  (
    { label, defaultChecked, onChange, ...props }: IInputCheckboxProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const [isActive, setIsActive] = useState(defaultChecked ?? false);

    const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
      (e) => {
        setIsActive((prev) => !prev);
        onChange && onChange(e);
      },
      [onChange],
    );

    useEffect(() => {
      setIsActive(defaultChecked ?? false);
    }, [defaultChecked]);

    return (
      <S.Container>
        <S.Label>{label}</S.Label>

        <S.InputWrapper $isActive={isActive}>
          <S.StyledInput
            ref={ref}
            onChange={handleChange}
            {...props}
            type="checkbox"
          />
          <S.Thumb />
        </S.InputWrapper>
      </S.Container>
    );
  },
);

InputCheckbox.displayName = 'InputCheckbox';

export default InputCheckbox;
